import React from "react"

function IconLayoutMinimized({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="layout-minimized"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-layout-minimized"{...props}><path d="M19.636 8.945c.603 0 1.091.489 1.091 1.091V14.4a1.09 1.09 0 0 1-1.09 1.09H4.363a1.09 1.09 0 0 1-1.091-1.09v-4.364c0-.602.488-1.09 1.09-1.09h15.273zm-.218 1.308H4.582v3.928h14.836v-3.928z" fill={color} fillRule="evenodd" style={{height: height || fontSize}} originalclass="__primary"/></svg>)
}

export default IconLayoutMinimized
